import React from 'react';
import { NavLink } from 'react-router-dom';
import './navBar.css'
import { useAuth } from '../../context/AuthContext';
import { useAlerts } from '../../context/AlertContext';

export default function NavBar() {
  const {logout, roles} = useAuth();
  const { maintenanceMessages } = useAlerts();
  const handleLogoutClick = () => {
    logout(); // Will clear token, user info, and redirect
  };

  //alert(roles)

  return (
    
    <nav className="nav-container">
      <NavLink to="/" className="nav-link" activeclassname="active-link">Home</NavLink>
        {roles && ( roles.includes("cdlisAdmin") ) &&   
        <>
          <NavLink to="/reports" className="nav-link" activeclassname="active-link">Reports</NavLink>
        </>
      }
      {/* <NavLink to="/faq" className="nav-link" activeclassname="active-link">FAQs</NavLink> */}
      <NavLink className="nav-link" activeclassname="active-link" onClick={handleLogoutClick}>Logout</NavLink>
      {maintenanceMessages.length > 0 && 
        <>
          <NavLink to="/messages" className="nav-link nav-warning-icon" activeclassname="active-link">&#9888;&#65039;</NavLink>
        </>}
    </nav>
  );
}
